import PropTypes from 'prop-types';

export default {
  taxesCopy: PropTypes.string,
  getTaxesPolicy: PropTypes.func.isRequired,
};
